import { useEffect, useState } from 'react';
import {
    ProjectCheckpoints,
    TasksModel,
} from '../../../../domain/projectCheckpoints/projectCheckpoints';
import { Link, useNavigate } from 'react-router-dom';
import { CreateProjectCheckpoint } from '../../../../domain/projectCheckpoints/createProjectCheckpoint';
import { ProjectCheckpointsRepository } from '../../../../infrastructure/repositories/projectCheckpoints/projectCheckpointsRepository';
import ProjectCheckpointDetailsSection from './ProjectCheckpointDetailsSection';
import FormErrorMessage from '../../../shared/components/forms/FormErrorMessage';
import ProjectCheckpointTasksSection from './ProjectCheckpointTasksSection';
import '../../styles/style.css'

interface Props {
    isNewProjectCheckpoint: boolean;
    projectId: string | undefined;
    projectCheckpoint?: ProjectCheckpoints | null;
}

export const ProjectCheckpointForm = ({
    isNewProjectCheckpoint,
    projectId,
    projectCheckpoint: selectedprojectCheckpoint,
}: Props) => {
    const initialState = selectedprojectCheckpoint ?? {
        id: 0,
        employeeId: 0,
        projectId: 0,
        projectName: '',
        summary: '',
        comments: '',
        date: '',
        tasks: [],
    };

    const [projectCheckpoint, setProjectCheckpoint] =
        useState<ProjectCheckpoints>(initialState);

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [isIncomplete, setIsIncomplete] = useState(true);

    const navigate = useNavigate();

    const handleInputChange = (
        name: string,
        value: string | boolean | number[] | number | undefined | TasksModel[]
    ) => {
        setProjectCheckpoint({ ...projectCheckpoint, [name]: value });
    };

    const handleAddTask = (task: TasksModel) => {
        setProjectCheckpoint((prev) => ({
            ...prev,
            tasks: [...projectCheckpoint.tasks, task],
        }));
    };

    const handleError = (error: any) => {
        setErrorMessage(error.response.data);
        setIsSubmitting(false);
        window.scrollTo({ behavior: 'smooth', left: 0, top: 0 });
    };

    const handleSubmit = (event: React.FormEvent) => {
        event.preventDefault();

        setIsSubmitting(true);
        setErrorMessage('');

        if (isNewProjectCheckpoint) {
            let body: CreateProjectCheckpoint = {
                employeeId: projectCheckpoint.employeeId,
                projectId: Number(projectId),
                comments: projectCheckpoint.comments,
                summary: projectCheckpoint.summary,
                tasks: projectCheckpoint.tasks,
            };

            ProjectCheckpointsRepository.CreateProjectCheckpoint(body)
                .then((response) => {
                    navigate(`/projects/projects-list/${projectId}`);
                    setIsSubmitting(false);
                })
                .catch(handleError);
        }
    };

    useEffect(() => {
        if (projectCheckpoint.employeeId && projectCheckpoint.comments) {
            setIsIncomplete(false);
        } else {
            setIsIncomplete(true);
        }
    }, [projectCheckpoint]);

    /**
     * State that controls the visibility of the ProjectCheckpointTasksSection component.
     */
    const [showTasksSection, setShowTasksSection] = useState(false);

    /**
     * Toggles the visibility of the ProjectCheckpointTasksSection.
     */
    const toggleTasksSection = () => {
        setShowTasksSection(prev => !prev);
    };
  
    return (
        <div>
            <FormErrorMessage errorMessage={errorMessage} />
            <div className='row'>
                <div className='col-xxl-12'>
                    <div className='card '>
                        <div className='card-body p-4'>
                            <div className='row'>
                                <ProjectCheckpointDetailsSection
                                    projectCheckpoint={projectCheckpoint}
                                    onChange={handleInputChange}
                                />
                                <hr className='mt-3'></hr>

                                <div className='mb-3 px-3'>
                                    <span
                                        onClick={toggleTasksSection}
                                        className="task-section-toggle"
                                        >
                                        
                                        {showTasksSection ? (
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ri-arrow-up-circle-line me-2 icon-size"></i>
                                                Ocultar tareas
                                            </span>
                                            ) : (
                                            <span className="d-inline-flex align-items-center">
                                                <i className="ri-add-circle-line me-2 icon-size"></i>
                                                Agregar tarea
                                            </span>
                                        )}
                                    </span>
                                </div>

                                {showTasksSection && (
                                    <div className='col-12'>
                                        <ProjectCheckpointTasksSection
                                            projectCheckpoint={projectCheckpoint}
                                            onChange={handleInputChange}
                                            onAddTask={handleAddTask}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex gap-2'>
                    <Link
                        to={`/projects/projects-list/${projectId}`}
                        className='btn btn-withe'
                    >
                        <i className='mdi mdi-arrow-left'></i> Atrás
                    </Link>

                    {isNewProjectCheckpoint ? (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            {isSubmitting ? 'Creando...' : 'Crear'}
                        </button>
                    ) : (
                        <button
                            className='btn btn-primary'
                            disabled={isSubmitting || isIncomplete}
                            onClick={handleSubmit}
                        >
                            <i className='ri-arrow-up-circle-line'></i>
                            {isSubmitting ? 'Actualizando...' : 'Actualizar'}
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
};
